import {
  createInputFeature,
  ExtractFeaturePayload,
} from '@smartsheet-dataflow/formjs';
import { BridgeFormJSState } from '../Types';
import { dummyDispatch } from '../params/ParamFromSchema';

export const {
  actionCreator: setIsOpenAction,
  selectorCreator: isOpenSelector,
  featureReducer: IsOpenFeature,
} = createInputFeature<'isOpen', IsOpenType>('isOpen');

export type IsOpenType = boolean;

export type IsOpenState = {
  isOpen: {
    [inputId: string]: boolean;
  };
};

export type IsOpenPayload = ExtractFeaturePayload<typeof setIsOpenAction>;

export const reduceIsOpen =
  (payload: IsOpenPayload) => (state: BridgeFormJSState) =>
    IsOpenFeature(state, setIsOpenAction(dummyDispatch)(payload));
